import { render, staticRenderFns } from "./PayPolicy.vue?vue&type=template&id=27f415a2&scoped=true&"
import script from "./PayPolicy.vue?vue&type=script&lang=js&"
export * from "./PayPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f415a2",
  null
  
)

export default component.exports